module.exports = __webpack_public_path__ + "media/images/turbochargers/04-bb153c477aa91cd739fe773a37efac49.png";